import * as React from 'react';

export class AuthenticationSuccessBus {
  private readonly channel?: BroadcastChannel;

  constructor() {
    if (typeof BroadcastChannel === 'function') {
      this.channel = new BroadcastChannel('auth-session');
    }
  }

  public async sendMessage(): Promise<void> {
    try {
      if (this.channel) {
        await this.channel.postMessage('login');
      }
    } catch {
      console.error('Failed to send message to broadcast channel!');
    }
  }

  public subscribe(): void {
    try {
      if (this.channel) {
        this.channel.onmessage = () => {
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        };
      }
    } catch {
      console.error('Failed to subscribe to broadcast channel!');
    }
  }

  public async unsubscribe(): Promise<void> {
    try {
      if (this.channel) {
        await this.channel.close();
      }
    } catch {
      console.error('Failed to close broadcast channel!');
    }
  }
}

export const authenticationBus = new AuthenticationSuccessBus();
export const useAuthorizationWatcher = (): void => {
  React.useEffect(() => {
    authenticationBus.subscribe();

    return () => {
      authenticationBus.unsubscribe();
    };
  }, []);
};
